// extracted by mini-css-extract-plugin
export var boldText = "_7r-4";
export var checkboxContainer = "_7r-6";
export var closeIcon = "_7r-i";
export var container = "_7r-0";
export var drawer = "_7r-8";
export var drawerContent = "_7r-9";
export var extraSmallText = "_7r-5";
export var fulfillmentGroupTable = "_7r-e";
export var largeText = "_7r-3";
export var loadingSpinnerContainer = "_7r-j";
export var mediumText = "_7r-2";
export var narrow = "_7r-f";
export var notificationLink = "_7r-l";
export var packageCheckIconContainer = "_7r-7";
export var slideoutHeaderActions = "_7r-g";
export var slideoutHeaderActionsShifted = "_7r-h";
export var slideoutHeaderContainer = "_7r-a";
export var slideoutModal = "_7r-c";
export var stickyHeaderWrapper = "_7r-b";
export var table = "_7r-k";
export var tableContainer = "_7r-d";
export var tertiaryText = "_7r-1";